import { RefObject, useEffect, useState } from 'react'

export const useScrollPositionInfoByRef = <T extends HTMLElement>(ref: RefObject<T>) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const handleScroll = () => {
      setIsScrolled(el.scrollTop > 0)
    }
    el.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => {
      el.removeEventListener('scroll', handleScroll)
    }
  }, [ref])

  return isScrolled
}
